export default __webpack_public_path__ + "static/media/Hair_11_M_C5.c26e3484.svg";